import { AuditLog, GetAuditLogRequest } from './inference.gen'
import { useTokenAndOrgId, processPaginatedData, InferenceAPI } from './utils'
import { useInfiniteQuery } from '@tanstack/react-query'

export const useGetAuditLogs = (payload: GetAuditLogRequest) => {
  const { orgId, token } = useTokenAndOrgId()

  return useInfiniteQuery({
    queryKey: ['audit-logs', orgId, payload],
    enabled: !!orgId && !!token,
    queryFn: async ({ pageParam = 1 }) => {
      const result = await InferenceAPI.getAuditLogs({
        data: {
          ...payload,
          user_id: payload.user_id || undefined,
          page_number: pageParam,
        },
      })
      return {
        instances: result.items,
        hasNextPage: result.total == payload.page_size,
        total: result.total,
      }
    },
    initialPageParam: 1,
    getNextPageParam: (lastPage, allPages) =>
      lastPage.hasNextPage ? allPages.length + 1 : undefined,
    select: (data) => {
      const { allInstances: allLogs, total } = processPaginatedData<AuditLog>(
        data.pages
      )
      return { allLogs, total }
    },
  })
}
